import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Container, Row, Col, Alert, Image } from "react-bootstrap";
import { ArrowLeftShort } from "react-bootstrap-icons";
import { useAuth } from "../contexts/AuthContext";
import Segment from "./Segment";
import Test from "./Test";
import SectionNavbar from "./SectionNavbar";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

function Section() {
  const { sectionSlug } = useParams();
  const { logout } = useAuth();
  const [section, setSection] = useState(null);
  const [segments, setSegments] = useState([]);
  const [segment, setSegment] = useState(null);
  const [test, setTest] = useState(null);
  const [accessDenied, setAccessDenied] = useState(false);
  const navigate = useNavigate();

  const retrieveSegments = async (setDefault = false) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/sections/${sectionSlug}/segments`, {
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setSegments(data);
        if (setDefault && data.length > 0) {
          setSegment(data[0]);
          setTest(null);
        }
      } else {
        console.error("Could not retrieve course module segments data:", data);
      }

    } catch (error) {
      console.error("Error retrieving course module segments data:", error);
    }
  };

  useEffect(() => {
    setSegment(null);
    setTest(null);
    const retrieveSection = async () => {
      try {
        const response = await fetch(`${API_URL}/api/v1/sections/${sectionSlug}`, {
          credentials: "include",
        });

        const data = await response.json();

        if (response.ok) {
          setSection(data);
        } else if (response.status === 403) {
          setAccessDenied(true);
        } else {
          console.error("Could not retrieve course module data:", data);
        }
      } catch (error) {
        console.error("Error retrieving course module data:", error);
      }
    };

    retrieveSection();
    retrieveSegments(true);
  }, [sectionSlug]);

  const retrieveSegment = async (segmentSlug) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/sections/${sectionSlug}/segments/${segmentSlug}`, {
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setTest(null);
        setSegment(data);
      } else {
        console.error("Could not retrieve course module segment data:", data);
      }
    } catch (error) {
      console.error("Error retrieving course module segment data:", error);
    }
  };

  const retrieveTest = async (type, sectionId) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/sections/${sectionSlug}/${type}/new?&section_id=${sectionId}`, {
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setSegment(null);
        setTest(data);
        console.log(data)
      } else {
        console.error("Could not render new test form:", data);
      }
    } catch (error) {
      console.error("Error rendering new test form:", error)
    }
  };

  if (accessDenied) {
    return (
      <Container className="section-purple py-5" fluid>
        <Alert variant="danger">
          <Alert.Heading>Access Denied</Alert.Heading>
          <p>You must complete the previous section before accessing this one.</p>
          <div className="d-flex justify-content-end">
            <Button onClick={() => navigate("/")} variant="outline-danger">
              Return to Dashboard
            </Button>
          </div>
        </Alert>
      </Container>
    );
  }

  const handleTestComplete = (type, sectionId) => {
    retrieveSegments();
    retrieveTest(type, sectionId);
  };

  const activeTestType = test?.type
    || (test?.existing_test?.type === 'PreTest' && 'pre_test')
    || (test?.existing_test?.type === 'PostTest' && 'post_test')
    || null;

  return (
    <div className="section-wrapper">
      <div
        className="section-banner"
        style={{ '--section-banner-url': `url(/${sectionSlug}.jpg)`
        }}
      >
        <div className="d-flex flex-column justify-content-between h-100">
          <Container className="d-flex flex-column justify-content-between" style={{ height: '250px' }}>
            <Row className="align-items-center pt-4">
              <Col xs={6}>
                <Link to="/">
                <Image src="/white-logo.png" alt="CTGWeb 2.0" className="hero-logo" />
                </Link>
              </Col>
              <Col xs={6} className="text-end">
                <Button className="logout-button" onClick={logout}>Logout</Button>
              </Col>
            </Row>
            <Row className="pb-4">
              <Col>
                <h1 className="hero-title mb-0">{section?.name}</h1>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <Container className="section-purple py-5" fluid>
        <Container>
          <Row className="pb-4">
            <Col>
              <div>
                <Button className="app-button" onClick={() => navigate("/")}>
                  <ArrowLeftShort fontSize="1.5rem" />Home
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <SectionNavbar
                section={section}
                segments={segments}
                currentSegment={segment}
                activeTestType={activeTestType}
                onSegmentSelect={retrieveSegment}
                onTestSelect={retrieveTest}
              />
            </Col>
            <Col md={9}>
              {segment ? (
                <Segment
                  segment={segment}
                  segments={segments}
                  section={section}
                  onSegmentSelect={retrieveSegment}
                  onTestSelect={retrieveTest}
                />
              ) : test ? (
                <Test
                  test={test}
                  section={section}
                  segments={segments}
                  onSegmentSelect={retrieveSegment}
                  onTestSubmit={handleTestComplete}
                />
              ) : null}
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Section;
